// From https://www.familysearch.org/artifactmanager/json_ArtifactScreeningState.html
export const SCREENING_STATE = {
  UNSCREENED: 'UNSCREENED',
  FIRST_SCREENING: 'FIRST_SCREENING',
  FIRST_DONE: 'FIRST_DONE',
  SECOND_SCREENING: 'SECOND_SCREENING',
  SECOND_DONE: 'SECOND_DONE',
  THIRD_SCREENING: 'THIRD_SCREENING',
  THIRD_DONE: 'THIRD_DONE',
  FOURTH_SCREENING: 'FOURTH_SCREENING',
  FOURTH_DONE: 'FOURTH_DONE',
  FIFTH_SCREENING: 'FIFTH_SCREENING',
  FIFTH_DONE: 'FIFTH_DONE',
  SIXTH_SCREENING: 'SIXTH_SCREENING',
  SIXTH_DONE: 'SIXTH_DONE',
  SEVENTH_SCREENING: 'SEVENTH_SCREENING',
  SEVENTH_DONE: 'SEVENTH_DONE',
  EIGHTH_SCREENING: 'EIGHTH_SCREENING',
  EIGHTH_DONE: 'EIGHTH_DONE',
  ESCALATE: 'ESCALATE',
  APPROVED: 'APPROVED',
  RESTRICTED: 'RESTRICTED',
  DELETED: 'DELETED',
  RESTORED: 'RESTORED',
}

export const SCREENING_TAG = {
  NOT_SET: 'NOT_SET',
  PORN: 'PORN',
  IMMODESTY: 'IMMODESTY',
  VIOLENCE_HATE: 'VIOLENCE_HATE',
  OTHER: 'OTHER',
  KISSING: 'KISSING',
  SACRED_CONTENT: 'SACRED_CONTENT',
  URLS: 'URLS',
  INAPPROPRIATE_CONTENT: 'INAPPROPRIATE_CONTENT',
  ORDINANCES: 'ORDINANCES',
  LIVING_REQUEST: 'LIVING_REQUEST',
  COPYRIGHT: 'COPYRIGHT',
}

// Used for photos admin filters, to filter by artifact type.
// This represents the actual file type of the artifact.
export const ARTIFACT_CATEGORY = {
  ANY: 'ANY',
  IMAGE: 'IMAGE',
  AUDIO: 'AUDIO',
  PDF: 'PDF',
  TEXT: 'TEXT',
  OBITUARY: 'OBITUARY',
  UNKNOWN: 'UNKNOWN',
  VIDEO: 'VIDEO',
}

// Used in Person -> Memories tab, to display icons that match the gallery.
// This represents the content category of the artifact (e.g. an image can have
// a content category of either photo or document; both text and audio artifacts
// will have a content category of story).
export const CONTENT_CATEGORY = {
  ANY: 'ANY',
  DOCUMENT: 'DOCUMENT',
  OBITUARY: 'OBITUARY',
  PHOTO: 'PHOTO',
  STORY: 'STORY',
  UNKNOWN: 'UNKNOWN',
}

/**
 * Map an ARTIFACT_CATEGORY to an appropriate searchCategories param
 * for use with the /artifacts/searchresults endpoint
 */
export const SEARCH_CATEGORY_MAPPING = {
  ANY: 'ANY',
  IMAGE: 'IMAGE',
  AUDIO: 'AUDIO',
  TEXT: 'TEXT',
  PDF: 'PDF',
}

// LocalStorage preference keys
export const LANGUAGE_PREF_KEY = 'artifactsadmin.filterLanguage'
export const COUNT_PREF_KEY = 'artifactsadmin.artifactsPerPage'

export const DEFAULT_PAGE_SIZE = 20

// Display a gray box as the source of artifact card image
// if thumbnails are hidden, the artifact was just barely deleted,
// or it was marked as porn
export const HIDDEN_ARTIFACT_IMAGE_SRC =
  "data:image/svg+xml,%3Csvg width='200' height='123' viewBox='0 0 200 123' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect width='200' height='123' rx='8' fill='%23C4C4C4'/%3E%3Crect width='200' height='123' rx='8' fill='black' fill-opacity='0.03'/%3E%3C/svg%3E%0A"
